import { createReducer } from '@reduxjs/toolkit';
import { GetTestITData, GetItemByBatch, postITR, GetToWhs } from './ITThunk';

// Utility function to handle pending, fulfilled, and rejected actions
const handleAsyncActions = (builder, action, dataKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[dataKey] = true;
      state[dataKey] = null;
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[dataKey] = false;
      state[dataKey] = action.payload;
      state.error[errorKey] = null;
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[dataKey] = false;
      state.error[errorKey] = action.payload;
    });
};

const initialState = {
  TestITData: null,
  ITItemData: null,
  postResponse: null,
  GetToWarehouse: null,

  // Dynamic loading and error states for each API
  loading: {
    TestITData: false,
    ITItemData: false,
    postResponse: false,
    GetToWarehouse: false,
  },

  error: {
    TestITDataError: null,
    ITItemDataError: null,
    postResponseError: null,
    GetToWarehouseError: null,
  },
};

export const ITReducer = createReducer(initialState, (builder) => {
  // Handle async actions using the utility function
  handleAsyncActions(builder, GetTestITData, 'TestITData', 'TestITDataError');
  handleAsyncActions(builder, GetItemByBatch, 'ITItemData', 'ITItemDataError');
  handleAsyncActions(builder, GetToWhs, 'GetToWarehouse', 'GetToWarehouseError');
  handleAsyncActions(builder, postITR, 'postResponse', 'postResponseError');
});

export default ITReducer;






// import { createReducer } from '@reduxjs/toolkit';
// // import { fetchGrpoData, postGrpoData } from './grporeduxthunk';  // assuming these are thunks
// import { GetTestITData,GetItemByBatch,postITR,GetToWhs } from './ITThunk';

// const initialState = {
//   TestITData: null,
//   loading: false,
//   error: null,
//   postResponse:null,
//   GetToWarehouse:null
// };

// export const ITReducer = createReducer(initialState, (builder) => {
//   builder
   
//     .addCase(GetTestITData.pending, (state) => {
//       state.loading = true;
//     })
  
//     .addCase(GetTestITData.fulfilled, (state, action) => {
//       state.loading = false;
//       state.TestITData = action.payload;
//       state.error = null;
//     })
 
//     .addCase(GetTestITData.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;
//     })
//     ///ITitemDetails
//     .addCase(GetItemByBatch.pending, (state) => {
//       state.loading = true;
//     })

//     .addCase(GetItemByBatch.fulfilled, (state, action) => {
//       state.loading = false;
//       state.ITItemData = action.payload;
//       state.error = null;
//     })
  
//     .addCase(GetItemByBatch.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;
//     })

//        //#region Get TO warehouse
//        .addCase(GetToWhs.pending, (state) => {
//         state.loading = true;
//       })
    
//       .addCase(GetToWhs.fulfilled, (state, action) => {
//         state.loading = false;
//         state.GetToWarehouse = action.payload;
//         state.error = null;
//       })
   
//       .addCase(GetToWhs.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       //#endregion

//     //Post response
//     .addCase(postITR.pending, (state) => {
//       state.loading = true;
//       state.postResponse = null;  // Reset post response before making the request
//     })
//     // Handle fulfilled state for PostItemCoilId (async)
//     .addCase(postITR.fulfilled, (state, action) => {
//       state.loading = false;
//       state.postResponse = action.payload;  // Store the response data from the POST request
//       state.error = null;
//     })
//     // Handle rejected state for PostItemCoilId (async)
//     .addCase(postITR.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;  // Handle error from the POST request
//     });
// });

// export default ITReducer;
